import React, { useEffect, useMemo, useRef, useReducer, useState } from 'react';
import { capitalLetter, formatDate, formatState, notify } from '../../../utils/utils';
import { ContenedorParametros } from '../../components/utils/ContenedorParametros'; 
import { BotonProcesar } from '../../components/buttons/BotonProcesar';
import { Tooltip } from '../../components/utils/Tooltip';
import { BotonNuevo } from '../../components/buttons/BotonNuevo';
import { BotonExportarExcel } from '../../components/buttons/BotonExportarExcel';
import { BotonGeneral } from '../../components/buttons/BotonGeneral';
import { Modal } from '../../components/modal/Modal';
import { useModal } from '../../../hooks/useModal';
import { DatePickerABX } from '../../components/pickers/DatePicker';
import { SearchTable } from '../../components/utils/SearchTable';
import { useBIM } from '../../../hooks/gestionMantenimientos/useBIM';
import { useUnidades } from '../../../hooks/gestionMantenimientos/useUnidades';
import { useSettings } from '../../../hooks/gestionMantenimientos/useSettings';
import { useBloqueoPantalla } from '../../../hooks/useBloqueoPantalla';
import { Select2 } from '../../components/forms/Select2';


export const Bim = () => {
    const classNameInput = "containerScroll text-white h-[30px] rounded px-4 w-full bg-zinc-800 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500"   
    const [isOpenRegistro, openModalRegistro, closeModalRegistro] = useModal()
    const [isOpenEliminar, openModalEliminar, closeModalEliminar] = useModal()
    const [bloquearPantalla,desbloquearPantalla,ComponenteBloqueo] = useBloqueoPantalla()

    const [startDate, setStartDate] = useState(() => {
        const today = new Date(); // Obtenemos la fecha actual
        const sevenDaysAgo = new Date(today); // Creamos una nueva fecha basada en la fecha actual
        sevenDaysAgo.setDate(today.getDate() - 7); // Establecemos la fecha 7 días antes
        return sevenDaysAgo; // Devolvemos la fecha actualizada
    });
    const [endDate, setEndDate] = useState(new Date())
    const [textoEliminacion,setTextoEliminacion] = useState('')

    const {
        incidenteDefault,
        incidente,
        setIncidente,
        listarBIM,
        incidentes,
        registrarEditarBIM,
        eliminarBIM,
        mostrarDocumentoActual,
        documentoActual,
        editarValorIncidencia
    } = useBIM()

    const {
        unidadesActivas,
        listadoUnidadesActivas
    } = useUnidades()

    const {
        listarConductores,
        conductores
    } = useSettings()

    useEffect(() => {
        (async () => {
            bloquearPantalla()
            await listarTabla()
            await listadoUnidadesActivas()
            await listarConductores()
            desbloquearPantalla()
        })()
    }, [])

    useEffect(() => {
        if(documentoActual){
            editarValorIncidencia('')
        }
    },[documentoActual])

    useEffect(() => {
        console.log("incidente -> ",incidente)
    },[incidente])

    //FUNCIONES CON LOS HOOKS
    const listarTabla = async () => {
        await listarBIM(formatDate(startDate),formatDate(endDate))
    }

    const funcionRegistroEdicion = async () => {
        if(incidente.codPersonaConductor != 0){
            const jsonData = await registrarEditarBIM()
            notify(jsonData.DesResultado,jsonData.CodResultado == 1 ? 'success' : 'error')
            if(jsonData.CodResultado == 1){
                closeModalRegistro()
                await listarTabla()
            }
        }else{
            notify("Seleccione un conductor",'error')
        }
    }

    const funcionEliminar = async () => {
        const jsonData = await eliminarBIM(textoEliminacion)
        notify(jsonData.DesResultado,jsonData.CodResultado == 1 ? 'success' : 'error')
        if(jsonData.CodResultado == 1){
            closeModalEliminar()
            await listarTabla()
        }
    }

    return (
        <>
            <ComponenteBloqueo></ComponenteBloqueo>

            <div className='w-full h-full flex flex-col'>
                <ContenedorParametros
                    titulo='Bitácora Incidentes Mantenimiento' tablaId="tablaId"
                >   
                    <div className="flex items-center">
                        <i className="mr-[10px] far fa-calendar-alt"></i>
                        <DatePickerABX className="" date={startDate} setDate={setStartDate}/>
                    </div>
                
                    <div className="flex items-center">
                        <i className="mr-[10px] far fa-calendar-alt"></i>
                        <DatePickerABX className="" date={endDate} setDate={setEndDate}/>
                    </div>
                    <BotonProcesar onClick={()=>listarTabla()}></BotonProcesar>       
                    <BotonNuevo 
                        onClick={() => {
                            mostrarDocumentoActual()
                            setIncidente(incidenteDefault)
                            openModalRegistro()
                        }}
                    >
                    </BotonNuevo>
                </ContenedorParametros>
                
                <Tooltip id={'Departamento'}>Departamento</Tooltip>
                <Tooltip id={'Provincia'}>Provincia</Tooltip>
                <Tooltip id={'Distrito'}>Distrito</Tooltip>
                <Tooltip id={'Estado'}>Estado</Tooltip>
                <Tooltip id={'Categoria'}>Categoria</Tooltip>

                <div className="containerScroll mt-7 relative flex-1 overflow-auto">
                    <table id="tablaId" className="tableResponsive">
                        <thead>
                            <tr>
                                <th className="">N°</th>
                                <th className="">FECHA CREACION</th>
                                <th className="">CODIGO</th>
                                <th className="">UNIDAD</th>
                                <th className="">CONDUCTOR</th>
                                <th className="">COMENTARIO</th>
                                <th className="">U. CREACION</th>
                                <th className="">ESTADO</th>
                                <th className=""></th>
                            </tr>
                        </thead>
                        <tbody>
                        {   
                            incidentes.length > 0 
                            ? incidentes.map((data, i) => {
                                return (
                                    <tr key={i+1} className=''>
                                        <td data-label="" className=' w-[20px]'> {i+1}</td>
                                        <td data-label="Nombre" className=" ">{data.fechaBim}</td>
                                        <td data-label="Marca" className=" ">{data.numDocumentoBim || '-'}</td>
                                        <td data-label="Codigo" className=" ">{data.unidad}</td>
                                        <td data-label="U. Medida" className=" ">{data.nomPersonaConductor}</td>
                                        <td data-label="P. Compra" className=" ">{data.comentarioBim}</td>
                                        <td data-label="P. Venta" className=" ">{data.nomUsuarioCreacion}</td>
                                        <td data-label="Caracteristicas" className='' ><span className={formatState(data.codEstado)}>{capitalLetter(data.nomEstado)}</span></td>
                                        <td data-label="Opciones" className="">
                                            <div className='flex items-center justify-end gap-2'>
                                                {
                                                    data.codEstado == 9 ?
                                                        <button 
                                                            onClick={() => {
                                                                setIncidente(Object.assign({},incidenteDefault,data))
                                                                openModalRegistro()
                                                            }}
                                                            className="bg-blue-500 hover:bg-blue-600 text-[14px] px-[5px] py-1 rounded shrink-0"
                                                        >
                                                            <i className="fas fa-edit"></i>
                                                        </button>
                                                    : ''
                                                }
                                                <button
                                                    onClick={() => {
                                                        setTextoEliminacion('')
                                                        setIncidente(Object.assign({},incidenteDefault,data))
                                                        openModalEliminar()
                                                    }}
                                                    className="bg-red-500 hover:bg-red-600 text-[14px] px-[5px] py-1 rounded shrink-0"
                                                >
                                                    <i className="fas fa-trash"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                )
                            })
                            : <tr><td colSpan="9" className="text-center">No hay información que mostrar con los parámetros seleccionados.</td></tr>
                        }
                        </tbody> 
                    </table>
                </div>
            </div>
            

            {/* MODALES */}
            <Modal 
                isOpen={isOpenRegistro} 
                closeModal={closeModalRegistro} 
                action={() => funcionRegistroEdicion()}
                title="Registrar BIM"
            >
                <div className="flex w-[550px] items-center flex-wrap justify-center">
                        <div className="w-full grid gap-4 grid-cols-3 px-4">
                                    <label>Fecha: </label>
                                    
                                    <div className="col-span-2 flex items-center lg:justify-center gap-4 w-[250px] lg:text-sm">
                                        <div>{formatDate(new Date())}</div>
                                        <i className='fa fa-calendar lg:hidden'/>
                                    </div>

                                    <label>Documento: </label>

                                    <div className="col-span-2 flex items-center lg:justify-center gap-4 w-[250px] lg:text-sm">
                                        <div>{incidente.numDocumentoBim || documentoActual}</div>
                                    </div>

                                    <label>Unidad: </label>

                                    <div className="col-span-2 flex items-center gap-4">
                                        <div className='w-full'>
                                            <Select2
                                                opciones={
                                                    [
                                                        {
                                                            text: '--Seleccione--',
                                                            value: 0
                                                        },
                                                        ...unidadesActivas.map((data,i) => {
                                                            return{
                                                                text: data.nomUnidad,
                                                                value: data.codUnidad
                                                            }
                                                        })
                                                    ]
                                                }
                                                value={incidente.codUnidad}
                                                functionChangeValue={(valor) => {
                                                    editarValorIncidencia('codUnidad',valor)
                                                    const codConductor = unidadesActivas.find(e => e.codUnidad == valor)?.codPersonaConductor || 0
                                                    const existeConductor = conductores.some(e => e.codPersona == codConductor)
                                                    editarValorIncidencia('codPersonaConductor', existeConductor ? codConductor : 0)
                                                }}
                                            ></Select2>
                                        </div>
                                    </div>
                                
                                    <label>Conductor: </label>

                                    <div className='col-span-2 w-full'>
                                        <Select2
                                            opciones={
                                                [
                                                    {
                                                        text: '--Seleccione--',
                                                        value: 0
                                                    },
                                                    ...conductores.map((data,i) => {
                                                        return{
                                                            text: data.nomPersona,
                                                            value: data.codPersona
                                                        }
                                                    })
                                                ]
                                            }
                                            value={incidente.codPersonaConductor}
                                            functionChangeValue={(valor) => {
                                                editarValorIncidencia('codPersonaConductor',valor)
                                            }}
                                        ></Select2>
                                    </div>
                                
                                    <label>Comentario: </label>

                                    <div className="col-span-2 flex items-center gap-4">
                                        <textarea value={incidente.comentarioBim} onChange={e => editarValorIncidencia('comentarioBim',e.target.value)} className={`${classNameInput} caret-input h-[100px]`}/>
                                    </div>
                        </div>
                </div>
            </Modal>

            <Modal
                isOpen={isOpenEliminar}
                title={'Eliminar inicidente'}
                action={funcionEliminar}
                closeModal={closeModalEliminar}
                textButtons={{confirm: 'sí', denied: 'no'}}
            >
                <div className='w-[400px] lg:w-full px-2 py-5 flex flex-col items-center justify-center gap-[20px]'>
                    <label>¿Está seguro de eliminar este incidente?</label>
                    <textarea value={textoEliminacion} onChange={e => setTextoEliminacion(e.target.value)} className={`${classNameInput} h-[80px] p-5 caret-white`} placeholder='(Comentario)'></textarea>
                </div>
            </Modal>
            
        </>
    )
}